"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = void 0;
var State;
(function (State) {
    State["Added"] = "ADDED";
    State["Deleted"] = "DELETED";
    State["Modified"] = "MODIFIED";
})(State = exports.State || (exports.State = {}));
